import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: 'ng-template[cignaModalContent]' })
export class ModalContentDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
